import { render, staticRenderFns } from "./TitleExpenseModal.vue?vue&type=template&id=56a17056&"
import script from "./TitleExpenseModal.vue?vue&type=script&lang=js&"
export * from "./TitleExpenseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports